module.exports = { raw: '8.12.2' };



//////////////////
// WEBPACK FOOTER
// ./~/auth0-js/src/version.js
// module id = 233
// module chunks = 0